var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13549 1.16231C9.39879 1.42561 9.39879 1.8525 9.13549 2.11577L5.53969 5.71157C5.27639 5.97487 4.84957 5.97487 4.58627 5.71157L0.990439 2.11577C0.727145 1.8525 0.727145 1.42561 0.990439 1.16231C1.25373 0.89902 1.68063 0.89902 1.94392 1.16231L5.06298 4.28134L8.18207 1.16231C8.44537 0.89902 8.87219 0.89902 9.13549 1.16231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdarrow);
export default __webpack_public_path__ + "static/media/ddarrow.759eb5e6468704c65441db00249f7bec.svg";
export { ForwardRef as ReactComponent };